import TagManager from "react-gtm-module";

const linkIsPressed = itemId => {
  TagManager.dataLayer({
    dataLayer: {
      event: "custom_event",
      event_category: "save",
      event_action: "openhouse_virtual",
      event_label: `${itemId}`
    }
  });
};

export { linkIsPressed };
